interface ApiConstantsInterface {
  baseUrl: string
  getRelatedProducts: (productId: number) => string
}

const apiConstants: ApiConstantsInterface = {
  baseUrl: '/api/related-products',
  getRelatedProducts: (productId: number) => `/${Math.trunc(productId)}`,
}

export { apiConstants, ApiConstantsInterface }
